<template>
	<div>
		<el-dialog title="查看失败原因" :visible.sync="dialogVisible" width="426px" :before-close="handleClose">
			<span>手动撤销, 撤销人: {{ operator }}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			dialogVisible: false,
		};
	},
	props: {
		operator: {
			type: String,
			default: () => '',
		},
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		handleClose(done) {
			done();
		},
	},
};
</script>
